import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailedPage: FC = () => {
  const navigate = useNavigate();

  const handleGoToVouchers = (): void => {
    navigate('/vouchers', { replace: true });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-seasalt p-6">
      <div className="flex flex-col items-center max-w-md w-full">
        <div className="mb-8">
          <i className="pi pi-times-circle text-[5rem] text-red-500" />
        </div>

        <h1 className="text-3xl font-bold text-red-500 mb-4 text-center">
          Payment Canceled
        </h1>

        <p className="text-lg text-primary-300 text-center mb-6 leading-7">
          Your voucher purchase was not completed.
        </p>

        <p className="text-sm text-gray-500 text-center mb-10 leading-5 px-2">
          If you believe this was a mistake, you can try the payment again or
          contact support for assistance.
        </p>

        <button
          onClick={handleGoToVouchers}
          className="bg-red-500 text-white font-semibold text-base py-4 px-8 rounded-xl w-full shadow-md shadow-red-500/30 hover:opacity-90 transition"
        >
          Go To Vouchers
        </button>
      </div>
    </div>
  );
};

export default PaymentFailedPage;
